/**
 * Cookie から CSRF トークンを読み取る。
 *
 * csrf_token は、サーバー側の login / refresh エンドポイントが
 * Set-Cookie ヘッダーで発行する非 HttpOnly Cookie。
 * JavaScript から読み取れるよう httpOnly: false で設定されている。
 * Double Submit Cookie パターンにより、この値を X-CSRF-Token ヘッダーに
 * 付与して送信することで CSRF 攻撃を防止する。
 */
export function getCsrfToken(): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(/(?:^|; )admin_csrf_token=([^;]*)/);
  return match?.[1] ? decodeURIComponent(match[1]) : null;
}
